<template>
  <!-- 異動区分　1：住所変更届 -->
  <div class="item">
    <b class="title required">郵便番号</b>
      <input-text type="text" v-model="idou.todokede1_naiyou" @blur="idou.todokede1_naiyou = convertNumber(idou, true)" :error="getError(idou, 'todokede1_naiyou')" placeholder="例）　000-0000"></input-text>
  </div>
  <div class="item">
    <b class="title required">住所</b>
    <input-text type="text" class="address" v-model="idou.todokede2_naiyou" :error="getError(idou, 'todokede2_naiyou')" placeholder="例）　〇〇県△△市□□区××町1-1 〇〇ビル101"></input-text>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useForm } from "@/composable/form/form";
import { Idou } from '@/types/Shinsei';
export default defineComponent({
  props:{
    idou: {
      type: Object as () => Idou,
      default: null
    },
  },
  setup(props) {

    // エラー取得
    const { getError } = useForm();

    const convertNumber = (idou: Idou | null, hyphen: boolean = false) => {
      if(!idou?.todokede1_naiyou){
        return null
      }
      const val = idou?.todokede1_naiyou
      
      if(hyphen){
        return val.replace(/[^0-9\-]/g,'')
      }else{
        return val.replace(/[^0-9]/g,'')
      }
    }

    return {
      getError,
      convertNumber,
    };
  },
  components: {},
});
</script>

<style lang="scss" scoped>
@import '@scss/components/shinsei-create.scss';
</style>
